/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */

import React from 'react';
import PropTypes from 'prop-types';
import { StyledModal, Text, ModalActions, ButtonGroup, Button } from 'sarsaparilla';

const propTypes = {
    isOpen: PropTypes.bool,
    closeModal: PropTypes.func,
};

export default function UnauthorizedErrorModal({ isOpen, closeModal }) {
    return (
        <StyledModal
            shouldShowCloseButton={false}
            shouldActionsStickInMobile
            size="md"
            isOpen={isOpen}
            heading="No Commercial Authorization"
            onRequestClose={closeModal}
        >
            <Text>
                {' '}
                You are not authorized to make commercial reservations at this location,
                please contact the facility for more information.
            </Text>

            <ModalActions>
                <ButtonGroup isFullWidthOnMobile={false} isStretchedToFit>
                    <Button onClick={closeModal} appearance="tertiary">
                        Close
                    </Button>
                </ButtonGroup>
            </ModalActions>
        </StyledModal>
    );
}

UnauthorizedErrorModal.propTypes = propTypes;
